"use client";

import { useState } from "react";
import { Link } from "react-router-dom"; // for routing
import { FaBars, FaTimes } from "react-icons/fa";

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev);

  return (
    <header className="bg-white shadow-md fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        {/* Straight Line Logo Arrangement */}
        <div className="flex space-x-4 items-center">
          <Link to="/">
            <img
              src="images/Logo1.png"
              alt="Logo1"
              width={70}
              height={70}
              className="rounded-full"
            />
          </Link>
          <Link to="/">
            <img
              src="/images/Logo2.jpeg"
              alt="Logo 2"
              width={100}
              height={100}
              className="rounded-full"
            />
          </Link>
          <Link to="/college">
            <img
              src="/images/Logo3.jpeg"
              alt="Logo 3"
              width={70}
              height={70}
              className="rounded-full"
            />
          </Link>
        </div>

        {/* Nav Links */}
        <nav className="hidden md:flex space-x-8">
          <Link to="/" className="hover:text-blue-600 font-medium">Home</Link>
          <Link to="/about" className="hover:text-blue-600 font-medium">About</Link>
          <Link to="/admission" className="hover:text-blue-600 font-medium">Admission</Link>
          <Link to="/contact" className="hover:text-blue-600 font-medium">Contact</Link>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white px-4 py-4 space-y-4">
          <Link to="/" className="block">Home</Link>
          <Link to="/about" className="block">About</Link>
          <Link to="/admission" className="block">Admission</Link>
          <Link to="/contact" className="block">Contact</Link>
        </div>
      )}
    </header>
  );
}
